import Barrage from './index.vue';

export default Barrage;
